import { render } from "./Dialogue.vue?vue&type=template&id=7d9e2a26"
import script from "./Dialogue.vue?vue&type=script&lang=js"
export * from "./Dialogue.vue?vue&type=script&lang=js"

import "./Dialogue.vue?vue&type=style&index=0&id=7d9e2a26&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__